import { useTranslation } from 'react-i18next';

import { Image, View } from '@react-pdf/renderer';
import { SmallHeading } from 'PDF/components/SmallHeading';

interface ISalesFunnelImagePdfProps {
  imageSrc: string;
  itemsNumber: number;
  isExamplePage: boolean;
}

export const SalesFunnelImagePdf = ({ imageSrc, itemsNumber, isExamplePage }: ISalesFunnelImagePdfProps) => {
  const { t } = useTranslation();
  return itemsNumber === 0 || !imageSrc ? null : (
    <>
      <View wrap={false} style={{ width: '100%', marginBottom: 30 }}>
        <SmallHeading heading={isExamplePage ? "Sales Funnel" : t('pdfPages.mappings.marketingAndSales.salesFunnel')} />
        <Image
          src={imageSrc}
          style={{
            margin: '0 auto',
          }}
        />
      </View>
    </>
  );
};
